<template>
  <modal ref="modal" contentClasses="px-5 py-4">
    <template v-slot:header>
      <p class="font-weight-semibold text-center">Contatto inviato!</p>
    </template>
    <p class="text-center">Aspetta la revisione della Direzione</p>
    <template v-slot:footer>
      <div class="d-flex w-100">
        <button
          type="button"
          class="btn btn-outline-primary mx-auto"
          @click.prevent="onCanceled"
        >
          Chiudi
        </button>
      </div>
    </template>
  </modal>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import Modal from "components/Modal.vue";

@Component({ components: { Modal } })
export default class WaitForSubmissionModal extends Vue {
  show() {
    const modal = this.$refs.modal as any;
    modal.show();
  }

  hide() {
    const modal = this.$refs.modal as any;
    modal.hide();
  }

  onCanceled() {
    this.hide();
    this.$emit("canceled");
  }
}
</script>

<style scoped></style>
